import * as slideout from './slideout';

export default {
  ...slideout,
  strict: true,
  namespaced: true,
};
